
import React, { useState } from "react"
import * as Constants from '../../../constants/urls';

const ProductRow=(props)=>{
    
    return(
        <React.Fragment>

<div className="row text-center anbarGardaniProductRow" style={{direction:"rtl",display : "flex",alignItems : "center",minHeight:"100px"}}> 

<div className="col-3 col-sm-2  p-0">
<img src={Constants.imagesBsaeUrl+'/image/resizeTest/shop/_1000x/thumb_' + props.image + '.jpg'} style={{width: '100%', height: '100%', borderRadius: '2px' ,cursor:"pointer"}} productId={props.productId} productUrl={props.productUrl} onClick={props.openShortcut} />
</div>
<div className="col-5 col-sm-6 px-1">
<p className="m-0">{props.name}</p>
<p className="m-0">{props.label}</p>

</div>
{console.log("props.prodStock",props.prodStock)}
{console.log("props.packId",props.packId)}
<div className="col-4">
{
             props.prodStock!=undefined &&    props.prodStock!=null && props.prodStock.map((item, index) => {return(
              item.packId==props.packId &&  <input type="text" packId={props.packId}  pattern="[0-9]*" inputMode="numeric" className="form-control" placeholder="موجودی" value={item.stock} onChange={props.changeStock}/>

              ) 
            })
        } 

  </div>

</div>   
 <div className="row">
  <div className="col">

 </div>
 </div>
  </React.Fragment>
        )
}
export default ProductRow;

